import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-gotx-key-value-list',
  templateUrl: './gotx-key-value-list.component.html',
  styleUrls: ['./gotx-key-value-list.component.scss']
})
export class GotxKeyValueListComponent implements OnInit {

  @Input('keyValueList') keyValueList: any[];
  @Input('rightBorder') rightBorder: boolean;
  @Input('dataSource') dataSource: any = null;
  @Input('listType') listType: string = 'simple';

  constructor() { }

  ngOnInit() {
    
  }

}